module.exports = __webpack_public_path__ + "img/bus-stop.68d2b8c8.svg";